import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import AdminDashboard from './pages/AdminDashboard';
import StudentDashboard from './pages/StudentDashboard';
import EmployeeDashboard from './pages/EmployeeDashboard';
import AddStudent from './pages/AddStudent';
import AddEmployee from './pages/AddEmployee';
import StudentDetails from './pages/StudentDetails';
import EmployeeDetails from './pages/EmployeeDetails';
import Home from './pages/Home';
import QuizPage from './pages/QuizPage';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import { ToastProvider } from './components/ToastContext';
import './App.css';

function App() {
  return (
    <ToastProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/login" element={<Login />} />
            <Route path="/home" element={
              <ProtectedRoute>
                <Home />
              </ProtectedRoute>
            } />
            <Route path="/admin" element={
              <AdminRoute>
                <AdminDashboard />
              </AdminRoute>
            } />
            <Route path="/student-dashboard" element={
              <ProtectedRoute>
                <StudentDashboard />
              </ProtectedRoute>
            } />
            <Route path="/quiz" element={
              <ProtectedRoute>
                <QuizPage />
              </ProtectedRoute>
            } />
            <Route path="/employee-dashboard" element={
              <ProtectedRoute>
                <EmployeeDashboard />
              </ProtectedRoute>
            } />
            <Route path="/add-student" element={
              <ProtectedRoute allowedRoles={['admin', 'manager']}>
                <AddStudent />
              </ProtectedRoute>
            } />
            <Route path="/add-employee" element={
              <ProtectedRoute allowedRoles={['admin', 'manager']}>
                <AddEmployee />
              </ProtectedRoute>
            } />
            <Route path="/edit-student/:id" element={
              <ProtectedRoute allowedRoles={['admin', 'manager']}>
                <AddStudent />
              </ProtectedRoute>
            } />
            <Route path="/edit-employee/:id" element={
              <ProtectedRoute allowedRoles={['admin', 'manager']}>
                <AddEmployee />
              </ProtectedRoute>
            } />
            <Route path="/student-details/:id" element={
              <ProtectedRoute allowedRoles={['admin', 'manager']}>
                <StudentDetails />
              </ProtectedRoute>
            } />
            <Route path="/employee-details/:id" element={
              <ProtectedRoute allowedRoles={['admin', 'manager']}>
                <EmployeeDetails />
              </ProtectedRoute>
            } />
            {/* Catch-all route for any invalid URLs - but exclude valid dashboard routes */}
            <Route path="*" element={
              <Navigate to="/login" replace />
            } />
          </Routes>
        </div>
      </Router>
    </ToastProvider>
  );
}

export default App;
